/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { Tabs, TabsPanel } from '@salesforce/design-system-react';
import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from 'react-responsive';
//V2 components
import { ProductHeader, ProductSideNav } from '../../../../components';
import ProductsInstanceList from '../ProductsInstanceList';
import ProductsMaintenanceList from '../ProductsMaintenanceList';
import { Pane, ProductsBody, Wrapper } from './styles';
import './styles.css';


class Products extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      url: PropTypes.string,
      path: PropTypes.string
    }),
    requests: PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = { menuOpen: false };
    this.toggleMenu = () => {
      return this.setState({ menuOpen: !this.state.menuOpen });
    };
  }

  render() {
    if (!this.props.requests.products.isCompleted) return null;

    const products = (this.props.requests.products.value || []).map((i) => {
      return {
        key: i.key,
        url: `/products/${i.key}`,
        customIcon: true,
        order: i.order
      };
    }).sort((a, b) => {
      return a.order - b.order;
    });

    products.unshift({
      key: 'Home',
      url: '/current',
      customIcon: false,
    });

    const currentProduct = this.props.requests.products.value
      .find((p) => {
        return p.key === this.props.match.params.product;
      }) || { key: 'Home' };

    return (
      <Wrapper>
        <MediaQuery minWidth={1024}>
          <ProductSideNav />
        </MediaQuery>
        <ProductsBody>
          <Pane>
            <ProductHeader product={currentProduct}/>
             <Tabs className="tabs-wrapper">
               <TabsPanel label="Status">
                 <ProductsInstanceList
                  displayControls={true}
                  product={this.props.match.params.product || 'home'} />
               </TabsPanel>
               <TabsPanel label="Maintenances">
                 <ProductsMaintenanceList />
               </TabsPanel>
             </Tabs>
          </Pane>
        </ProductsBody>
      </Wrapper>
    );
  }
}

export default Products;
